var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconTwoArrows(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 31",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.175.003H4.825A4.825 4.825 0 000 4.83v20.349a4.825 4.825 0 004.825 4.825h20.35A4.825 4.825 0 0030 25.178V4.828A4.825 4.825 0 0025.175.004z",
    fill: "#FFD83B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.175 30.003H15v-30h10.175A4.825 4.825 0 0130 4.838v20.337a4.824 4.824 0 01-4.825 4.828z",
    fill: "#FFB24D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.414 16.826a.858.858 0 00.585.27.851.851 0 00.586-.27l6.81-6.821a.828.828 0 000-1.17l-.49-.527a.846.846 0 00-1.17 0l-5.736 5.718-5.72-5.724a.846.846 0 00-1.185 0l-.5.5a.843.843 0 000 1.185l6.82 6.84z",
    fill: "#5560FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.905 14.675a.845.845 0 00-1.17 0l-5.736 5.718-5.72-5.724a.846.846 0 00-1.186 0l-.5.504a.84.84 0 000 1.17l6.821 6.853c.155.16.364.255.585.267a.86.86 0 00.586-.267l6.82-6.83a.852.852 0 000-1.19l-.5-.5z",
    fill: "#5560FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTwoArrows);
export default __webpack_public_path__ + "static/media/Icon-two-arrows.7fd1a7aa.svg";
export { ForwardRef as ReactComponent };